import * as React from 'react';
import { connect } from 'react-redux';
import DataTable from '../../DataTable';
import moment from 'moment';
import SelectList from '../../RBSelectList/RBSelectList';
import { ILookupType } from '../common/defaults';
import { toast } from 'react-toastify';
import {
  getAllTypes,
  getLookupTypes,
  getLookupsByType,
  saveLookup,
} from '../redux-objects/actions';
import { Form, Button, Modal } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { GetURIByParts } from '../../../services/Utils/StringUtils';
import { addLookupLog } from '../logging/auditLog';
import { UserInfo } from '../../Login/common/defaults';
import CommentModal from '../../CommentModal/CommentModal';
import { getCounties } from '../../WorkflowQueues/Keywords/redux-objects/actions';
import { getTableValuesByGroupName } from '../../../services/Utils/IndexedDBUtils';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

enum ServiceEndPoints {
  GetAllTypes = 'GetAllTypes',
  GetLookupTypes = 'GetTypeTables',
  GetLookupsByType = 'GetTypesByName',
  UpdateType = 'UpdateType',
}
export interface ILookupTypeActionProps {
  getAllTypes?: (url: string) => void;
  getLookupTypes?: (url: string) => void;
  getLookupsByType?: (url: string, type: string) => void;
  saveLookup?: (url: string, lookup: ILookupType, type: string) => void;
}

interface ILookupTypeStateProps {
  lookups: ILookupType[];
  lookupTypes: { name: string, value: string | number }[];
  selectedLookupType: string;
  webServiceURL: string;
  elasticSearchURL: string;
  currentUser: UserInfo;
}

interface ILookupTypesProps
  extends ILookupTypeActionProps,
  ILookupTypeStateProps { }

const initialState = {
  logData: [],
  tableColumns: [],
  lookupTypes: [],
  selectedLookupType: '-1',
  tableKey: 1,
  showModal: false,
  showEditModal: false,
  showCommentModal: false,
  comment: '',
  selectedLookup: null,
  editName: '',
  editDescription: '',
  editHsiValue: '',
  editCountyId: null,
  pendingAction: '',
  isNewLookup: false,
  buttonDisabled: false,
  counties: [],
};

type LookupTypeVieiwerState = Readonly<typeof initialState>;

class LookupTypes extends React.Component<
  ILookupTypesProps,
  LookupTypeVieiwerState
> {
  public constructor(props: ILookupTypesProps) {
    super(props);
    this.state = initialState;
  }

  private lookupController: string = 'Lookup';

  closeModal = (e?) => {
    this.setState({
      showModal: false,
    });
  };

  closeEditModal = (e?) => {
    this.setState({
      showEditModal: false,
    });
  };

  handleAddUpdateLookup = (e?) => {
    this.setState({
      pendingAction: 'addUpdate',
      showCommentModal: true,
      isNewLookup: false
    });
  };

  cancelComment = () => {
    this.setState({
      comment: '',
      showCommentModal: false,
    });
  };

  saveComment = () => {
    if (this.state.pendingAction == 'addUpdate') this.addUpdateLookup();
    if (this.state.pendingAction == 'delete') this.doDelete();
  };

  addUpdateLookup = (e?) => {
    const current = this.state.selectedLookup;
    this.setState(
      {
        showCommentModal: false,
        pendingAction: '',
        selectedLookup: {
          ...this.state.selectedLookup,
          name: this.state.editName,
          description: this.state.editDescription,
          hsiValue: this.state.editHsiValue,
          active: true,
          countyId: this.state.editCountyId,
        },
      },
      () => {
        this.saveLookup();
        this.setState(
          {
            showEditModal: false,
          },
          () => {
            toast.success('Saved!');
          }
        );

        //Audit Logging
        const action = current.id ? 'Edited ' : 'Added ' + ' Lookup Value';
        let desc = current.id
          ? 'Edited ' +
          this.state.selectedLookupType +
          ' - ' +
          current.name +
          ' : ' +
          current.description +
          ' to ' +
          this.state.editName +
          ' : ' +
          this.state.editDescription
          : 'Added ' +
          this.state.selectedLookupType +
          ' - ' +
          this.state.editName +
          ' : ' +
          this.state.editDescription;

        if (
          (this.state.editHsiValue && this.state.editHsiValue.length) > 0 ||
          (current.hsiValue && current.hsiValue.length > 0)
        ) {
          const hsi = current.id
            ? ' HSI ' + current.hsiValue + ' to ' + this.state.editHsiValue
            : ' HSI ' + this.state.editHsiValue;
          desc += hsi;
        }

        addLookupLog(
          this.props.elasticSearchURL,
          action,
          desc,
          this.props.currentUser.username,
          this.state.comment
        );
      }
    );
  };

  saveLookup = (e?) => {
    this.props.saveLookup(
      GetURIByParts(
        this.props.webServiceURL,
        this.lookupController,
        ServiceEndPoints.UpdateType
      ),
      this.state.selectedLookup,
      this.state.selectedLookupType
    );
  };

  handleDelete(event: React.MouseEvent<HTMLElement>, rowData: any) {
    this.setState({
      selectedLookup: rowData,
      pendingAction: 'delete',
      showCommentModal: true,
    });
  }

  doDelete() {
    this.state.selectedLookup.active = false;
    this.saveLookup();
    this.setState(
      { showCommentModal: false, pendingAction: '', showEditModal: false },
      () => {
        toast.error('Deleted');
      }
    );

    addLookupLog(
      this.props.elasticSearchURL,
      'Deleted Lookup',
      'Deleted ' +
      this.state.selectedLookupType +
      ' - ' +
      this.state.selectedLookup.name +
      ' : ' +
      this.state.selectedLookup.description,
      this.props.currentUser.username,
      this.state.comment
    );
  }

  handleLookupTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState(
      {
        selectedLookupType: value,
      },
      () => {
        this.populateTable();
      }
    );
  }

  populateTable() {
    this.props.getLookupsByType(
      GetURIByParts(
        this.props.webServiceURL,
        this.lookupController,
        ServiceEndPoints.GetLookupsByType
      ),
      this.state.selectedLookupType
    );
  }

  componentDidMount() {
    this.props.getLookupTypes(
      GetURIByParts(
        this.props.webServiceURL,
        this.lookupController,
        ServiceEndPoints.GetLookupTypes
      )
    );

    if (this.state.counties.length === 0) {
      getTableValuesByGroupName("County").then((results) => {
        this.setState({ counties: results.map(c => ({ name: `${c.name} - ${c.description}`, value: c.id })) });
      });
    }
  }

  handleEdit(event: React.MouseEvent<HTMLElement>, rowData: any) {
    this.setState({
      editName: rowData.name,
      editDescription: rowData.description,
      editHsiValue: rowData.hsiValue,
      selectedLookup: rowData,
      showEditModal: true,
      isNewLookup: false,
      buttonDisabled: false,
      editCountyId: rowData.countyId,
    });
  }

  handleAddNew = (e?) => {
    this.setState({
      editName: '',
      editDescription: '',
      editHsiValue: '',
      selectedLookup: {},
      showEditModal: true,
      isNewLookup: true
    });
  };

  handleView(event: React.MouseEvent<HTMLElement>, fullData: any) {
    this.setState({
      selectedLookup: fullData,
      showModal: true,
      isNewLookup: false
    });
  }

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case 'name': {
        const typed = el.value.trim();
        let valueTaken = false;

        if (this.state.isNewLookup && typed.length > 1) {
          const arr = this.getLookupsArray();              // ILookupType[]
          const isCity = this.isCitySelected();

          if (isCity) {
            // If county not chosen yet, skip duplicate check for now
            const countyId = this.state.editCountyId;
            if (countyId != null) {
              valueTaken = arr.some(o =>
                (o.name || '').trim().toLowerCase() === typed.toLowerCase() &&
                Number(o.countyId ?? -1) === Number(countyId)
              );
            }
          } else {
            valueTaken = arr.some(o =>
              (o.name || '').trim().toLowerCase() === typed.toLowerCase()
            );
          }

          if (valueTaken) {
            toast.error('Decode Name Already Exists: Please Enter a NEW Decode Value');
            this.setState({ buttonDisabled: true, editName: typed });
            break;
          }
        }

        this.setState({ editName: typed, buttonDisabled: false });
        break;
      }
      case 'description':
        this.setState({
          editDescription: el.value,
        });
        break;
      case 'hsiValue':
        this.setState({
          editHsiValue: el.value,
        });
        break;
      case 'comment':
        this.setState({
          comment: el.value,
        });
        break;
      case 'countyId':
        console.log({ e });
        this.setState({
          editCountyId: parseInt(el.value),
        });
        break;
      default:
        break;
    }
  };

  private isCitySelected(): boolean {
  const selected = this.props.lookupTypes?.find(
    t => String(t.value) === String(this.state.selectedLookupType)
  );
  return (selected?.name || '').toLowerCase() === 'city';
}

private getLookupsArray(): ILookupType[] {
  const { lookups } = this.props; 
  if (Array.isArray(lookups)) return lookups;

  return Object.values(lookups ?? {}) as ILookupType[];
}

  public render() {
    const options = {
      dom: 'Bfrtip',
    };

    const columns = [
      {
        title: '',
        data: 'id',
      },
      {
        title: 'Name / Code',
        data: 'name',
      },
      {
        title: 'Description',
        data: 'description',
      },
      {
        title: 'HSI Value',
        data: 'hsiValue',
      },
    ];

    const lookupsArr = this.getLookupsArray();

    const columnDefs: any[] = [
      {
        targets: 0,
        width: '200px',
        orderable: false,
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-warning'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleEdit(cellData, rowData)}
              >
                {' '}
                Edit
              </Button>{' '}
              <Button
                variant='outline-danger'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleDelete(cellData, rowData)}
              >
                {' '}
                Del
              </Button>{' '}
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleView(cellData, rowData)}
              >
                {' '}
                Info
              </Button>
            </div>,
            td
          ),
      },
    ];

    const hasCounty = lookupsArr.some(l => !!l && l.countyId != null);
    if (hasCounty) {
      columns.push({
        title: 'County',
        data: 'countyId',
      });
      columnDefs.push({
        targets: 4,
        render: (countyId: number) => {
          const county = this.state.counties.find(c => c.value === countyId);
          if (!county) return '';

          return county.name;
        }
      })
    }

    return (
      <div className='app'>
        <div className='row'>
          {this.props.lookupTypes.length > 0 && (
            <SelectList
              className='w-25'
              data={this.props.lookupTypes}
              onChange={(e) => this.handleLookupTypeChange(e)}
              value={this.state.selectedLookupType}
              placeholder='Select a Lookup Type'
            />
          )}
          <br />
          <br />
        </div>
        {this.state.selectedLookupType != '-1' && (
          <div>
            {this.getLookupsArray().length > 0 && (
              <div>
                <Button
                  id='btnAddNew'
                  type='button'
                  className='btn btn-primary'
                  onClick={(e) => this.handleAddNew(e)}
                >
                  + Add New
                </Button>
                <DataTable
                  key={this.state.selectedLookupType}
                  id='tblLookupViewer'
                  data={this.getLookupsArray()}
                  columns={columns}
                  columnDefs={columnDefs}
                  actionsColumn='first'
                  order={[[1, 'asc']]}
                  {...options}
                />
              </div>
            )}

            <Modal show={this.state.showModal} onHide={this.closeModal}>
              <Modal.Header closeButton>
                <Modal.Title> Full Lookup Value Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <pre>
                    {JSON.stringify(this.state.selectedLookup, null, 4)}
                  </pre>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='secondary' onClick={this.closeModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal show={this.state.showEditModal} onHide={this.closeEditModal}>
              <Modal.Header closeButton>
                <Modal.Title>Lookup Value</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <Form>
                    <Form.Group controlId='Name'>
                      <Form.Label>
                        <strong>Name</strong>
                      </Form.Label>
                      <Form.Control
                        type='text'
                        data-field='name'
                        placeholder='Enter name/code'
                        onChange={this.handleChange}
                        value={this.state.editName}
                      />
                    </Form.Group>
                    <Form.Group controlId='Description'>
                      <Form.Label>
                        <strong>Description</strong>
                      </Form.Label>
                      <Form.Control
                        type='text'
                        data-field='description'
                        placeholder='Enter description'
                        onChange={this.handleChange}
                        value={this.state.editDescription}
                      />
                    </Form.Group>
                    <Form.Group controlId='HsiValue'>
                      <Form.Label>
                        <strong>HSI Value</strong>
                      </Form.Label>
                      <Form.Control
                        type='text'
                        data-field='hsiValue'
                        placeholder='(If applicable)'
                        onChange={this.handleChange}
                        value={this.state.editHsiValue}
                      />
                    </Form.Group>

                    {this.isCitySelected() &&
                      <Form.Group controlId='countyId'>
                        <Form.Label>
                          <strong>County</strong>
                        </Form.Label>
                        <SelectList
                          data={this.state.counties}
                          onChange={this.handleChange}
                          value={this.state.editCountyId}
                          placeholder='Select a Lookup Type'
                          datafield='countyId'
                        />
                      </Form.Group>
                    }
                  </Form>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='secondary' onClick={this.closeEditModal}>
                  Close
                </Button>
                <Button variant='success' disabled={this.state.buttonDisabled} onClick={this.handleAddUpdateLookup}>
                  Save
                </Button>
              </Modal.Footer>
            </Modal>
            <CommentModal
              comment={this.state.comment}
              show={this.state.showCommentModal}
              onCommentChange={this.handleChange}
              onCloseCommentModal={this.cancelComment}
              onCancel={this.cancelComment}
              onSave={this.saveComment}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lookupTypes: state.LookupTypes.lookupTypes,
    lookups: state.LookupTypes.lookups,
    webServiceURL: state.Application.backendURL,
    elasticSearchURL: state.Application.elasticSearchURL,
    currentUser: state.Application.currentUser,
  };
};

const mapDispatchToProps = {
  getAllTypes,
  getLookupTypes,
  getLookupsByType,
  saveLookup,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookupTypes);
